import { useGetAccountPayableReports } from 'api-hooks/report';
import useDefaultValuesReportDate from 'hooks/use-default-values-report-date';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function AccountPayableReport() {
  const { t } = useTranslation();
  const defaultFilters = useDefaultValuesReportDate('transaction');

  return (
    <PivotReportTemplate
      title={t('common:account_payable_report')}
      usePivotQuery={useGetAccountPayableReports}
      completeName={['agent']}
      defaultFilters={defaultFilters}
    />
  );
}
